var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selectInput"},[_c('input',{staticClass:"k-checkbox checkBoxcss",attrs:{"type":"checkbox","refs":"myButton","id":_vm.feature.id},domProps:{"value":_vm.feature.id,"checked":_vm.checkSelected}})])}
var staticRenderFns = []

export { render, staticRenderFns }